export const CURRENT_LOCATION_INFO = "CURRENT_LOCATION_INFO";
export const CATEGORIES_LIST = "CATEGORIES_LIST";
export const SERVICE_LIST = "SERVICE_LIST";
export const CURRENCY_SYMBOL = "CURRENCY_SYMBOL";
export const CART_DATA = "CART_DATA";
export const STORE_TYPE = "STORE_TYPE";
export const STORE_LOCATION = "STORE_LOCATION";
export const CHECKOUT_NAVIGATION = "CHECKOUT_NAVIGATION";
export const STORE_FLAT_STREET = "STORE_FLAT_STREET";
export const PICKUP_LOCATION = "PICKUP_LOCATION";
export const DESTINATION_LOCATION = "DESTINATION_LOCATION";
export const VEHICLE_LIST = "VEHICLE_LIST";
export const PICKUPDATE_TIME = "PICKUPDATE_TIME";
export const WAY_TYPE = "WAY_TYPE";
export const ACCEPT_COOKIES = "ACCEPT_COOKIES";
export const RETURNDATE_TIME = "RETURNDATE_TIME";
export const SHOWMODIFY = "SHOWMODIFY";
export const CABBOOK_NAVIGATION = "CABBOOK_NAVIGATION";
export const SET_STORE_MODAL_POPUP_SHOW = "SET_STORE_MODAL_POPUP_SHOW";